module.exports = __webpack_public_path__ + "static/media/field-hockey.fc039c39.svg";